const apofinder = {
  landingPage: {
    findPharmacy: 'Find Pharmacy',
    subtitle: 'Find thousands of pharmacies in Germany as well as pharmacies with emergency services on IhrApotheken.de.',
    scanCode: 'Scan pharmacy code',
    searchLabel: 'Please enter your location',
    tipTitle: 'Receive medication quickly',
    tipBullets: {
      1: '<b>choose local pharmacy</b>',
      2: 'Order medication <b>online</b> and redeem prescriptions',
      3: '<b>Pay online</b>',
      4: 'Have it conveniently <b>delivered</b>',
    },
    scan: {
      title: 'Scan pharmacy code',
      subtitle: 'If you have received a pharmacy code, you can scan it here. The relevant pharmacy will be registered as your preferred pharmacy.',
      problem: 'Having trouble scanning?',
      tips: {
        mainTitle: 'Scanning Tips',
        title1: 'Where can I find the scannable code?',
        title2: 'Which codes can be scanned?',
        title3: 'What to do if the code is not recognized?',
        content1: 'You can get the scannable code from your local pharmacy. Just speak to the staff.',
        content2: 'The pharmacy codes are special codes that you only receive from participating pharmacies. Other QR codes are not supported for pharmacy selection.',
        content3: 'If the code is not recognized immediately, move or tilt the camera slightly over the code. You can also change the distance. In any case, make sure you have good lighting!',
        scanningProblem: 'Other scanning problems?',
        link: 'Report a problem',
      },
    },
  },
  apofinderItem: {
    noPreorders: 'No online order is not possible via this order path',
    noPreordersTooltip: {
      heading: 'You will be redirected',
      content: 'You can redeem your (e-)prescription as usual in the pharmacy or in the Gematik app.',
    },
    noFreeSpotsTooltip: {
      heading: 'No online order possible here',
      content: 'Unfortunately there are no more places available on this day. Please adjust your filter criteria to find a free appointment at this pharmacy.',
    },
    appointmentBooking: 'Book an appointment',
    deliveryPossible: 'Delivery possible',
    pickupAtPharmacy: 'Pickup at the pharmacy',
    onlinePaymentPossible: 'Online payment possible',
    requestProduct: 'Request product',
    freeSpots: '{spots} free spots',
    freeSpot: '1 free spot',
    noFreeSpots: 'Fully booked',
    express: 'Express',
    delivery: 'Delivery',
    onlinePayment: 'Online payment',
    slotsInHours: '{count} appointments available in {hours} hours',
    slotInHours: '1 appointment available in {hours} hours',
    noSlotsAvailable: 'No appointments available in the next {hours} hours.',
    slotsAvailable: 'Appointments available',
    bookAppointment: 'Book an appointment at this pharmacy',
  },
  apofinderMap: {
    searchOnMapMove: 'Search while I move the map',
    filterDropdown: {
      noqLabel: 'Book appointment in',
      iadeLabel: 'Order medicines in',
    },
    accordion: {
      title: 'Find pharmacies near you',
      answerIade: 'Please select a pharmacy you would like to order from.',
      answerNoq: 'Please select a pharmacy with which you would like to book an appointment.',
    },
    openSidebar: 'Open sidebar',
    closeSidebar: 'Close sidebar',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
  },
  apofinderPharmacyList: {
    changePharmacy: 'Change Pharmacy',
    choosePharmacy: 'Select another pharmacy near you.',
    selectedPharmacy: 'Currently selected pharmacy',
    selectedPharmacyMob: 'Current regular pharmacy',
    findPharmacy: 'Find Pharmacy',
    scanPharmacy: 'Scan pharmacy code',
    otherPharmacies: 'Other pharmacies nearby',
    showFreeAppointmentsTip: 'You will be shown free appointments within the next 24 hours',
    loadMore: 'Load more',
    noPharmacies: 'No pharmacies found',
    noResults: {
      title1: 'Customize search',
      content1: 'No pharmacy with the searched criteria was found. Please adjust your input or filters.',
      title2: 'Enter address',
      content2: 'Please enter your address so we can search for pharmacies near you where you can pre-order your medication.',
      content3: 'Please enter more than 3 letters so that we can suggest pharmacies near you.',
    },
    showSidebarList: 'Show',
    hideSidebarList: 'Hide',
  },
  filterTabs: {
    noqLabelShort: 'Appointment booking',
    noqLabelLong: 'Appointment booking',
    iadeLabel: 'Shopping',
  },
  noqModal: {
    title: 'Appointment Overview',
    info: 'You will be shown available appointments within the next {hours} hours',
    button: 'Book an appointment',
  },
  apofinderSearchInput: {
    placeholder: 'Please enter your location',
    currentLocation: 'Find current location',
    clear: 'clear',
  },
  popper: {
    redirectionTooltip: {
      heading: 'You will be redirected',
      content: 'You will be redirected to our service partner No-Q for the appointment booking. Here you can quickly and easily book appointments in your pharmacy.\n\nEnter an address or a postal code to find pharmacies in your area. Select the desired location to go to the corresponding booking page.',
    },
    deliveryConditions: {
      orderConfirmation: 'Within {time} minutes of order confirmation',
      nextDelivery: 'Next possible delivery time',
      pickupTip: 'Your pharmacy will inform you as soon as the product is ready for you to collect.',
    },
    partners: {
      title: 'Partner Programs',
      phytothek: 'This pharmacy specializes in herbal therapy.',
      basica: 'In this pharmacy you can get Basica products as well as comprehensive advice.',
    },
  },
  onlinePreorder: 'Online order',
  deactivatedPharmacy: 'Unfortunately, this pharmacy is no longer available. Please select another pharmacy.',
  deactivatedPharmacySelected: 'Unfortunately, the pharmacy you requested is no longer available. You can keep your chosen pharmacy or choose another pharmacy.',
  camera: {
    1: 'To scan your pharmacy code, you must activate your camera. You can find out how to do this',
    2: 'here',
  },
  qr: {
    error: 'Please use a QR code from your pharmacy. Unfortunately, other QR codes are not possible.',
  },
  maintain: 'Maintance',
  cardLink: {
    alert: 'Redeem e-prescriptions from your health card? Click',
    here: 'here',
    title: 'Redeem e-prescription from health card?',
    descriptionBottomSheet: 'Now also online at your favorite pharmacy. Simply download the app from IhreApotheken.de and redeem.',
    descriptionModal: 'Would you like to redeem your e-prescription from your health card? Now also online at your favorite pharmacy. Simply download the app from IhreApotheken.de and redeem.',
    step1: 'Scan QR code',
    step2: 'Download the app',
    step3: 'Redeem e-prescription',
  },
  pharmacyTypeSelector: {
    title: 'Looking for a pharmacy that can do more?',
    supplierPharmacy: 'Supplier Pharmacy',
    medicalSupplyPrescriptions: 'Redeem Medical Supply Prescriptions',
  },
  laboratoryTests: 'Sale of Test Sets',
}

export default apofinder
